import React from 'react';

export const FontFamilyPreview = ({ fontFamily }: Props) => (
    <span style={{ fontFamily }}>
        {fontFamily}
    </span>
);

type Props = {
    fontFamily: string;
};